import patrionIcon from "../../../assets/icons/Patrion.svg";
import discordIcon from "../../../assets/icons/Discord.svg";
import telegramIcon from "../../../assets/icons/Telegram.svg";

export const socialLinks = [
    { img: patrionIcon, href: "https://www.patreon.com/ru-RU" },
    { img: discordIcon, href: "https://discord.com/" },
    { img: telegramIcon, href: "https://web.telegram.org/" },
];
